import { SearchMapContextProvider } from '@sales-app/context/searchMap'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import React from 'react'

import { SearchMap as SearchMapView } from './SearchMap'

export interface SearchMapProps {
  allowMapInteractions?: boolean
  bookablePerson: WorkspaceTab
}

export function SearchMap({ allowMapInteractions, bookablePerson }: SearchMapProps): JSX.Element {
  return (
    <SearchMapContextProvider>
      <SearchMapView allowMapInteractions={allowMapInteractions} bookablePerson={bookablePerson} />
    </SearchMapContextProvider>
  )
}
